/** UX-only mirror: the gateway is the real boundary. permissions = {module: level}. */
const ORDER = { none: 0, read: 1, write: 2 };

export function can(permissions, module, action) {
  const level = permissions?.[module] || 'none';
  return action === 'read' ? ORDER[level] >= ORDER.read : ORDER[level] >= ORDER.write;
}

export function canRead(permissions, module) {
  return can(permissions, module, 'read');
}

export function canWrite(permissions, module) {
  return can(permissions, module, 'write');
}
